module.exports = __webpack_public_path__ + "img/6.49327e90.png";